import { Col, Row } from "antd";
import PropTypes from "prop-types";
import React, { ReactElement, useEffect, useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";

const SupplierDetails = ({
  SupplierDetails,
}: {
  SupplierDetails: any;
}): ReactElement => {
  const [getBannerDetails, setBannerDetails] = useState(undefined);

  useEffect(() => {
    if (SupplierDetails) {
      setBannerDetails(SupplierDetails);
    }
  }, [SupplierDetails]);

  return (
    <React.Fragment>
      <Row gutter={5}>
        <Col span={24} style={{ background: "#fff" }}>
          <div className="user-information-show-tab-wrapper">
            <div className="inner-content">
              <div className="single-content">
                <div className="single-information-user-wrapper mb-3">
                  <div className="single-information-user-content">
                    <div className="info-body user-personal-inforamtion">
                      <h3 className="title">Basic Information</h3>
                      <div className="inner-body-wrapper">
                        <div className="inner-body">
                          <div className="single">
                            <div className="info-name">
                              <span>Name</span>
                            </div>
                            <div className="info-desc">
                              <span>{getBannerDetails?.name}</span>
                            </div>
                          </div>

                          <div className="single">
                            <div className="info-name">
                              <span>Contact Number</span>
                            </div>
                            <div className="info-desc">
                              <span>
                                {getBannerDetails?.mobileNumber?.split("+88")}
                              </span>
                            </div>
                          </div>

                          <div className="single">
                            <div className="info-name">
                              <span>ID</span>
                            </div>
                            <div className="info-desc">
                              <span>{getBannerDetails?.id}</span>
                            </div>
                          </div>

                          <div className="single">
                            <div className="info-name">
                              <span>Address</span>
                            </div>
                            <div className="info-desc">
                              <span>{getBannerDetails?.address}</span>
                            </div>
                          </div>

                          <div className="single">
                            <div className="info-name">
                              <span>Latitude</span>
                            </div>
                            <div className="info-desc">
                              <span>
                                {getBannerDetails?.location?.latitude}
                              </span>
                            </div>
                          </div>

                          <div className="single">
                            <div className="info-name">
                              <span>Longitude</span>
                            </div>
                            <div className="info-desc">
                              <span>
                                {getBannerDetails?.location?.longitude}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};
SupplierDetails.propTypes = {
  match: PropTypes.object,
  params: PropTypes.object,
};
export default SupplierDetails;
